// ABOUTME: Grouped crossing list across all children for the "All Kids" quick-record tab (Issue #1939).
// ABOUTME: Wraps useCrossings' parent-multi mode as a single hook call, not per-child in a .map().

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { useCrossings } from '../../hooks/useCrossings';
import CrossingList from './CrossingList';
import CrossingEntryDialog from './CrossingEntryDialog';

interface CrossingListAllKidsProps {
  childIds: number[];
  childNameById: Record<number, string>;
  familyTimezone?: string;
}

export default function CrossingListAllKids({ childIds, childNameById, familyTimezone }: CrossingListAllKidsProps) {
  const { items, error } = useCrossings({ mode: 'parent-multi', childIds, familyTimezone });
  const [openCrossingId, setOpenCrossingId] = useState<number | null>(null);
  const navigate = useNavigate();

  if (childIds.length === 0) {
    return null;
  }

  if (error) {
    return <Typography variant="body2" color="error">Couldn&apos;t load crossings</Typography>;
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <>
      <CrossingList items={items} onOpen={setOpenCrossingId} groupByChild childNameById={childNameById} />
      {openCrossingId != null && (
        <CrossingEntryDialog
          open
          crossingId={openCrossingId}
          onDismiss={() => setOpenCrossingId(null)}
          onConfirm={(id) => navigate(`/crossing/${id}`)}
        />
      )}
    </>
  );
}
